'use strict';
var EducationPartnerController = /** @class */ (function () {
    /*@ngInject*/
    function EducationPartnerController($scope, EducationSubNavService) {
        this.headerContent = "We all know how important it is to have a strong community! So we are proud to partner with experts in the field of integrative medicine to bring you access to cutting edge information to help you build your clinical and business expertise.";
        this.education_Partner = [
            {
                "id": "education_Kalish",
                "imageFileName": "170302-EducationalPartners-Kalish-358-214.png",
                "state_id": "partnerKalish",
                "title": "Daniel Kalish, DC",
                "content": " Daniel Kalish, DC believes that physical health is our platform for emotional and spiritual growth - and that we each have the ability to fully heal ourselves."
            },
            {
                "id": "education_AmericanInstituteOfIntegrativeOncology",
                "imageFileName": "AmericanInstituteOfIntegrativeOncology.png",
                "title": "American Institute of Integrative Oncology Research and Education",
                "content": "Emerson Ecologics and Wellevate Practitioners can now Learn Dr. Chilkov’s OutSmart Cancer™ System Foundations of Integrative Oncology | Self-Paced Professional Online Training.",
                "hyperLinkUrl": "https://go.emersonecologics.com/nalinichilkov-outsmartcancersystem"
            },
            {
                "id": "education_Tap",
                "imageFileName": "17_Tap_web_sizes_358x214_menu.png",
                "state_id": "tapItegrativePage",
                "title": "TAP Integrative",
                "content": "TAP Integrative is dedicated to bringing your key business education and clinical resources that help you build your dream practice."
            }
        ];
        $scope.$ctrl.value.selectedpageindex = 4;
        $scope.$ctrl.value.level = '2';
        this.eduSubNavService = EducationSubNavService;
        this.eduSubNavService.level = '2';
    }
    return EducationPartnerController;
}());
export default EducationPartnerController;
//# sourceMappingURL=education-partner.controller.js.map